import numberCounter from './directives/numberCounter';

export default
{
    numberCounter
}